import {CONFIG_URL,checkedConfig,checkedIdentity,checkedCatalog,checkedOrder,selectionOf,canonical,enabled,serviceOrigin,invalid} from './aplus-wechat-contract';

export class AplusWechatClient {
 constructor(identity,{fetchImpl=(...args)=>fetch(...args),clock=()=>Date.now(),timeoutMs=10000}={}){
  this.identity=checkedIdentity(identity);this.fetch=fetchImpl;this.clock=clock;this.timeoutMs=timeoutMs;this.disposed=false;this.generation=0;this.controllers=new Set();
 }
 dispose(){this.disposed=true;this.generation++;for(const c of this.controllers)c.abort();this.controllers.clear();}
 async request(url,{body,authenticated=false}={}){
  if(this.disposed)throw invalid('SESSION_CHANGED');
  const generation=this.generation,controller=new AbortController();this.controllers.add(controller);
  const timer=setTimeout(()=>controller.abort(),this.timeoutMs);
  try{
   const response=await this.fetch(url,{method:body?'POST':'GET',mode:'cors',credentials:'omit',cache:'no-store',redirect:'error',signal:controller.signal,
    headers:{'Content-Type':'application/json',...(authenticated?{Authorization:this.identity.accessToken}:{})},...(body?{body:JSON.stringify(body)}:{})});
   if(this.disposed||generation!==this.generation)throw invalid('SESSION_CHANGED');
   if(!response.ok){const error=invalid('APLUS_WECHAT_UNAVAILABLE');error.status=response.status;try{const v=await response.json();if(typeof v.code==='string'&&/^[A-Z_]{1,80}$/.test(v.code))error.code=v.code;}catch(_){}throw error;}
   const value=await response.json();if(this.disposed||generation!==this.generation)throw invalid('SESSION_CHANGED');return value;
  }finally{clearTimeout(timer);this.controllers.delete(controller);}
 }
 async config(){return checkedConfig(await this.request(CONFIG_URL),this.clock());}
 async catalog(config,selection){
  if(!enabled(config,this.clock()))throw invalid('APLUS_WECHAT_DISABLED');
  const params=new URLSearchParams();if(selection)for(const [k,v] of Object.entries(selectionOf(selection)))params.set(k,k==='packageActivity'?canonical(v):String(v));
  const value=await this.request(config.apiBaseUrl+'/v1/catalog'+(params.toString()?'?'+params:''),{authenticated:true});
  return checkedCatalog(value,this.identity,config,this.clock());
 }
 async create(config,intent){
  if(!enabled(config,this.clock()))throw invalid('APLUS_WECHAT_DISABLED');
  return checkedOrder(await this.request(config.apiBaseUrl+'/v1/orders',{body:intent,authenticated:true}),this.identity,intent);
 }
 async status(config,intent){
  // Status remains readable after admissions are switched off, but an origin
  // restored from local storage must never receive a session token.
  if(!config||!serviceOrigin(config.apiBaseUrl)||config.expiresAt<=this.clock())throw invalid('INVALID_APLUS_WECHAT_ORIGIN');
  return checkedOrder(await this.request(config.apiBaseUrl+'/v1/orders/'+encodeURIComponent(intent.requestId),{authenticated:true}),this.identity,intent);
 }
}
